export default {
      id: "avatar-usage",
      viewBox: "0 0 12 14",
      url: "/assets/" + "icons.svg#avatar",
      toString: function () {
        return this.url;
      }
    }